export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-72x72-427d56b5166fbb27147a915c79c8cf47.png";